module.exports = __webpack_public_path__ + "images/onboarding-banner/one-thing.ef8fda2ea2bd9d8e390b.png";